import { jsxs, jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { useId } from "./useId.js";
function Group({
  title,
  action,
  children,
  ...props
}) {
  const id = useId("list-group-header");
  return /* @__PURE__ */ jsxs("div", {
    ...props,
    children: [/* @__PURE__ */ jsxs(Header, {
      children: [/* @__PURE__ */ jsx("span", {
        id,
        children: title
      }), action]
    }), /* @__PURE__ */ jsx("div", {
      "aria-describedby": id,
      children
    })]
  });
}
const Header = styled.div.withConfig({
  displayName: "Header",
  componentId: "sc-1hlvuel-0"
})(["display:flex;justify-content:space-between;align-items:center;padding:", " 0 ", ";color:", ";"], token.spacing3, token.spacing2, token.colorText);
export {
  Group
};
//# sourceMappingURL=Group2.js.map
